import { COLOR } from '@/utils/constants';
import styled from 'styled-components';

export const RadioLabel = styled.label`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
`;

export const HiddenRadio = styled.input.attrs({ type: 'radio' })`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 1rem;
  height: 1remm;
  border: 2px solid ${COLOR.GREY75};
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;

  &:checked {
    border: 2px solid ${COLOR.BRAND_PRIMARY};
  }

  &:checked::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 60%;
    height: 60%;

    background-color: ${COLOR.BRAND_PRIMARY}; /* Blue inner circle */
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }
`;
